import { Component } from '@angular/core';
import { Router } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { SapCategoryService } from 'src/app/services/sap-category.service';

@Component({
  standalone: false,
  selector: 'app-sap-categories-add',
  templateUrl: './sap-categories-add.component.html',
})
export class SapCategoriesAddComponent {
  form: any = {
    name: '',
    sap_category_id: '',
    status: 1,
  };
  validationTriggered = false;

  constructor(
    private toaster: ToastrService,
    private router: Router,
    private sapCategoryService: SapCategoryService,
  ) {}

  submit(): void {
    this.validationTriggered = true;
    if (!this.form.name) {
      this.toaster.error('Please fill in all required fields.');
      return;
    }

    const payload = {
      name: this.form.name,
      sap_category_id: this.toNullableInt(this.form.sap_category_id),
      status: Number(this.form.status),
    };

    this.sapCategoryService.create(payload).subscribe({
      next: (result) => {
        this.toaster.success('SAP category added.');
        this.router.navigate(['/ecomm/sap-categories', result.data.id]);
      },
      error: (error) => {
        this.toaster.error(error?.error?.message || 'Failed to add SAP category.');
      },
    });
  }

  onSapCategoryIdInput(event: Event): void {
    const input = event.target as HTMLInputElement;
    const digits = input.value.replace(/\D/g, '');
    this.form.sap_category_id = digits;
    if (input.value !== digits) {
      input.value = digits;
    }
  }

  private toNullableInt(value: unknown): number | null {
    if (value === '' || value === null || value === undefined) {
      return null;
    }
    const parsed = Number(value);
    return Number.isFinite(parsed) ? parsed : null;
  }
}
